import { useState, useEffect, useRef } from 'react';
import { NSButtonBlue } from './NSButtonBlue';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import Styles from './NSMenuAction.module.css';
import { NSButtonOnClickProps } from './NSButton';

export interface NSMenuActionProps extends IBaseComponentProps
{
	id: string
	menu_item: string;
	onClick: NSButtonOnClickProps;
	isActive: () => boolean;
}

export interface NSMenuActionState
{
	isShow: boolean;
}

export function NSMenuAction(props: { name: string, items: NSMenuActionProps[] })
{
	const [state, setState] = useState<NSMenuActionState>({
		isShow: false
	});

	const menuRef = useRef<HTMLDivElement>(null);

	useEffect(() =>
	{
		function handleClickOutside(event: MouseEvent)
		{
			if (menuRef.current && !menuRef.current.contains(event.target as Node))
			{
				setState({ isShow: false });
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () =>
		{
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [menuRef]);

	function onClick(item: NSMenuActionProps, onFinished: () => void)
	{
		try
		{
			if (item.isActive())
				item.onClick.action(onFinished);
			else
				onFinished();
		} catch (error)
		{
			onFinished();
		}
	}

	if (props.items.length === 0)
		return <></>;
	if (props.items.length === 1)
		return <NSButtonBlue
			title={props.items[0].menu_item}
			onClick={{
				action: (onFinished) =>
				{
					onClick(props.items[0], onFinished);
				},
				showLoading: props.items[0].onClick.showLoading
			}}
			disabled={props.items[0].isActive() ? false : true}
			classList={[Styles.ns_menu_action_button]}
			loading={{
				hideContainer: true
			}}
		/>;
	return (
		<div className={Styles.ns_menu_action} ref={menuRef}>
			<button
				onClick={() => setState((prevState) => ({
					...prevState, isShow: !state.isShow
				}))}>
				{props.name}
				<img
					className={Styles.ns_menu_action_icon}
					src="https://static.namirasoft.com/image/concept/ellipsis/vertical-blue.svg"
					alt="Icon"
					width={24}
					height={24}
				/>
			</button>
			<ul className={`${Styles.ns_menu_action_item_holder} ${state.isShow ? Styles.ns_menu_action_show : Styles.ns_menu_action_hide}`}>
				{
					props.items.map((item) =>
						<li
							key={item.id}
							onClick={() => onClick(item, () => { })}
							className={`${Styles.ns_menu_action_item} ${item.isActive() ? Styles.ns_active_item : Styles.ns_menu_action_item_deactive}`}
						>
							{item.menu_item}
						</li>
					)
				}
			</ul>
		</div>
	);
}